import React from 'react'

export const TarefaStatusEnum = {
  ABERTO: 'Aberto',
  REABERTO: 'Reaberto',
  ANALISE: 'Análise',
  REANALISE: 'Reanálise',
  PENDENTEFILIAL: 'Aguardando Liberação',
  PENDENTEMOTORISTA: 'Pendente',
  LIBERADOVIAGEM: 'Liberado',
  LIBERADOSEMMONITORAMENTO: 'Liberado sem Monitoramento',
  FINALIZADA: 'Finalizada',
  CANCELADA: 'Cancelada',
  NAORECOMENDADA: 'Não Recomendada',
  STANDBY: 'Stand-by'
}

export const TarefaStatusColors = {
  ABERTO: '#ededed',
  ABERTO_DARK: '#9e9e9e',
  REABERTO: '#e3e3e3',
  REABERTO_DARK: '#aeaeae',
  ANALISE: '#fff176',
  ANALISE_DARK: '#fbc02d',
  REANALISE: '#ffb74d',
  REANALISE_DARK: '#f57c00',
  PENDENTEFILIAL: '#ce93d8',
  PENDENTEFILIAL_DARK: '#8e24aa',
  PENDENTEMOTORISTA: '#e57373',
  PENDENTEMOTORISTA_DARK: '#e53935',
  CANCELADA: '#bdbdbd',
  CANCELADA_DARK: '#616161',
  FINALIZADA: '#81c784',
  FINALIZADA_DARK: '#388e3c',
  NAORECOMENDADA: '#9fa8da',
  NAORECOMENDADA_DARK: '#3949ab',
  LIBERADOVIAGEM: '#64b5f6',
  LIBERADOVIAGEM_DARK: '#1976d2',
  LIBERADOSEMMONITORAMENTO: '#a1887f',
  LIBERADOSEMMONITORAMENTO_DARK: '#6d4c41'
}

export const InvertTarefaStatusEnum = Object.entries(TarefaStatusEnum).reduce(
  (p, c) => {
    const [key, value] = c
    p[value] = key
    return p
  },
  {}
)

export function TarefaBadgeStatus({ status }) {
  return (
    <div
      style={{
        padding: 10,
        borderRadius: 10,
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
        backgroundColor: TarefaStatusColors[InvertTarefaStatusEnum[status]],
        textAlign: 'center',
        lineHeight: '100%'
      }}
    >
      {status}
    </div>
  )
}
